export const defaultRiskManagementValues = { register: 15.0, consultation: 5.0 };
